// react
import { Map } from "immutable";
import moment from "moment";

const initialState = Map();

export default function requests(state = initialState, action) {
	switch (action.type) {
		case "REQUEST:TRACK":
			if (action.direction === "outgoing") {
				return state.set(action.name, Map({ sent: moment(), received: null, succeeded: null }));
			}

			if (action.direction === "incoming") {
				return state.withMutations((mutable) => {
					mutable.setIn([action.name, "received"], moment());
					mutable.setIn([action.name, "succeeded"], action.succeeded);
				});
			}

			return state;

		default:
			return state;
	}
}
